// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbBox":"breadCrumbBox--RND-H","title":"title--k-PuO"};